<template>
    <div class="business">
        <Header></Header>
        <div class="business_container business_container_bg1">
            <div class="main_content">
                <div class="business_title">线下零售解决方案</div>
                <div class="business-bg1-box">
                    <div class="business-bg1-box-title">行业背景：</div>
                    <div class="business-bg1-box-text">
                        线下零售行业作为实体消费的重要载体，始终在居民生活中占据关键地位。随着消费升级和数字化转型的推进，消费者对购物体验的要求不断提升，从快速收银到清晰的消费凭证，从商品溯源到退换货便捷性，都成为影响顾客满意度的重要因素。热敏打印机作为线下零售场景中信息输出的核心设备，广泛应用于收银小票打印、价签打印、库存标签打印等环节，其打印速度、清晰度、稳定性以及与零售管理系统的兼容性，直接关系到门店的收银效率、运营管理水平和顾客购物体验，是支撑线下零售门店高效运转的基础设备。

                        在日常运营中，热敏打印的收银小票是消费凭证的重要载体，价签和库存标签则是商品信息传递和库存管理的关键工具。一套可靠的热敏打印解决方案，能够帮助零售企业减少收银排队时间、降低价签错误率、优化库存管理流程，从而提升整体运营效率和顾客满意度。
                    </div>
                </div>
            </div>
        </div>
        <div class="business_container business_container_write">
            <div class="main_content">
                <div class="business-tabs">
                    <div class="business-tab" v-for="(tab, index) in tabList" :key="tab.title + index"
                         :class="{active: activeTabIndex === index}" @click="activeTabIndex = index">
                        <img v-if="index === 0" src="../images/icon1.png" alt="icon">
                        <img v-else-if="index === 1" src="../images/icon2.png" alt="icon">
                        <img v-else-if="index === 2" src="../images/icon3.png" alt="icon">
                        {{ tab.tabName }}
                    </div>
                </div>
                <div class="business_title">
                    {{ tabList[activeTabIndex].title }}
                </div>
                <div class="business_subtitle"> {{ tabList[activeTabIndex].subtitle }}</div>
                <div class="business-block" v-if="tabList[activeTabIndex].beds.length === 4">
                    <div class="business-block-item1">场景痛点</div>
                    <div class="business-block-item" v-for="(bed, index) in tabList[activeTabIndex].beds"
                         :key="bed.title+index">
                        <div class="business-block-item-title">{{ bed.title }}</div>
                        <div class="business-block-item-content">
                            <div class="business-block-item-text">{{ bed.text }}</div>
                            <img v-if="index === 0" class="business-block-item-img" src="../images/icon4.png"
                                 alt="img"/>
                            <img v-else-if="index === 1" class="business-block-item-img" src="../images/icon5.png"
                                 alt="img"/>
                            <img v-else-if="index === 2" class="business-block-item-img" src="../images/icon6.png"
                                 alt="img"/>
                            <img v-else-if="index === 3" class="business-block-item-img" src="../images/icon7.png"
                                 alt="img"/>
                        </div>
                    </div>
                </div>
                <div class="business-block2" v-else>
                    <div class="business-block-item1">场景痛点</div>
                    <div class="business-block-item" v-for="(bed, index) in tabList[activeTabIndex].beds"
                         :key="bed.title+index">
                        <div class="business-block-item-title">{{ bed.title }}</div>
                        <div class="business-block-item-text">{{ bed.text }}</div>
                        <img v-if="index===0" class="business-block-item-img" src="../images/icon4.png" alt="img"/>
                        <img v-else-if="index===1" class="business-block-item-img" src="../images/icon5.png" alt="img"/>
                        <img v-else-if="index===2" class="business-block-item-img" src="../images/icon6.png" alt="img"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="business_container business_container_gray">
            <div class="main_content">
                <div class="business_title">解决方案</div>
                <div class="business_subtitle">{{ tabList[activeTabIndex].solution }}</div>
                <template v-if="activeTabIndex ===0">
                    <div class="business-solution-content">
                        <img class="business-solution-content-printer-img" src="@/views/printer/images/DP358&DP458.png"
                             alt="printer">
                        <div class="business-solution-content-printer">
                            <div class="business-solution-content-printer-title">
                                <span class="other-color">DP358</span> 高速热敏云打印机
                            </div>
                            <div class="business-solution-content-printer-subtitle">
                                自动接单，自动打印
                            </div>
                            <div class="business-solution-content-printer-list">
                                打印速度：180mm/s<br/>
                                分辨率：203dpi<br/>
                                支持纸张宽度：58mm<br/>
                                接口：usb、WiFi<br/>
                                日均打印量：1000-3000单<br/>
                                适用场景：连锁超市、便利店、百货、商场等收银场景。
                            </div>
                        </div>
                    </div>
                    <div class="business-solution-content">
                        <div class="business-solution-content-gj">
                            <div class="business-solution-content-gj-title">
                                <img src="../images/gj.png" alt="gj">
                                快麦云
                            </div>
                            <div class="business-solution-content-gj-subtitle"></div>
                            <div class="business-solution-content-gj-kmy-text">
                                支持与主流收银系统无缝对接，自动抓取交易信息并生成规范小票；提供小票模板自定义功能，可灵活添加门店信息、促销活动、会员二维码等内容；具备设备状态监控和耗材管理功能，确保打印设备稳定运行。
                            </div>
                        </div>
                        <img class="business-solution-content-gj-img" src="../CYWM/images/3.png" alt="printer">
                    </div>
                </template>
                <template v-else-if="activeTabIndex === 1">
                    <div class="business-solution-content">
                        <img class="business-solution-content-printer-img" src="@/views/printer/images/DP158.png"
                             alt="printer">
                        <div class="business-solution-content-printer">
                            <div class="business-solution-content-printer-title">
                                <span class="other-color">DP158</span> 热敏云票据打印机
                            </div>
                            <div class="business-solution-content-printer-subtitle">
                                自动接单，自动打印，具备防卡纸设计和故障自动上报功能
                            </div>
                            <div class="business-solution-content-printer-list">
                                打印速度：120mm/s<br/>
                                分辨率：203dpi<br/>
                                支持纸张宽度：58mm<br/>
                                接口：usb、WiFi<br/>
                                日均打印量：800-2000单<br/>
                                适用场景：大型商场自助结账区、无人便利店等场景小吃店等场景
                            </div>
                        </div>
                    </div>
                    <div class="business-solution-content">
                        <div class="business-solution-content-gj">
                            <div class="business-solution-content-gj-title">
                                <img src="../images/gj.png" alt="gj">
                                快麦云
                            </div>
                            <div class="business-solution-content-gj-subtitle"></div>
                            <div class="business-solution-content-gj-kmy-text">
                                支持与各类自助结账系统深度适配，优化打印流程；提供打印异常自动重试功能，减少打印失败率；支持订单数据实时同步至商场管理后台。
                            </div>
                        </div>
                        <img class="business-solution-content-gj-img" src="../CYWM/images/1.png" alt="printer">
                    </div>
                </template>
                <template v-else-if="activeTabIndex === 2">
                    <div class="business-solution-content">
                        <img class="business-solution-content-printer-img" src="@/views/printer/images/KM-360AN.png"
                             alt="printer">
                        <div class="business-solution-content-printer">
                            <div class="business-solution-content-printer-title">
                                <span class="other-color">KM-360A</span> 便携式热敏标签打印机
                            </div>
                            <div class="business-solution-content-printer-subtitle">
                                移动便携，内置大容量锂电池可外出打印
                            </div>
                            <div class="business-solution-content-printer-list">
                                打印速度：80mm/s<br/>
                                分辨率：203dpi<br/>
                                支持纸张宽度：20-80mm<br/>
                                接口：蓝牙5.0、usb接口<br/>
                                日均打印量：单次充电可打1500-2000单<br/>
                                适用场景：具备防摔防尘设计适用于零售仓库、货架补货、商品盘点等场景
                            </div>
                        </div>
                    </div>
                    <div class="business-solution-content">
                        <div class="business-solution-content-gj">
                            <div class="business-solution-content-gj-title">
                                <img src="../images/gj.png" alt="gj">
                                快麦云和番茄打印管家软件
                            </div>
                            <div class="business-solution-content-gj-subtitle"></div>
                            <div class="business-solution-content-gj-kmy-text">
                                支持从库存系统同步商品 SKU、数量、批次等信息，一键生成入库 / 盘点标签；提供标签模板自定义功能，可添加二维码便于扫码追溯；支持离线打印模式，网络不佳时也能正常作业。
                            </div>
                        </div>
                        <img class="business-solution-content-gj-img" src="./images/bg.png" alt="printer">
                    </div>
                </template>
            </div>
        </div>
        <div class="business_container business_container_white">
            <div class="main_content">
                <div class="business_title">方案优势</div>
                <div class="business-good">
                    <div class="business-good-item" v-for="(good, index) in tabList[activeTabIndex].goods"
                         :key="good.title + index">
                        <img v-if="index === 0" src="../images/icon8.png" alt="icon">
                        <img v-else-if="index === 1" src="../images/icon9.png" alt="icon">
                        <img v-else-if="index === 2" src="../images/icon10.png" alt="icon">
                        <img v-else-if="index === 3" src="../images/icon11.png" alt="icon">
                        <div class="business-good-item-title">{{ good.title }}</div>
                        <div class="business-good-item-text">{{ good.text }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="business_container business_container_gray">
            <div class="main_content">
                <div class="business_title">场景典型客户案例</div>
                <div class="business-collaborative">
                    <template v-if="activeTabIndex === 0">
                        鲜丰水果品牌在全国门店部署快麦 DP358G 快麦云票据打印机和快麦云后，收银台小票打印速度提升了
                        40%，高峰时段排队时间缩短了 30%，因小票模糊导致的退换货纠纷减少了 60%，通过耗材预警功能，耗材库存成本降低了
                        15%。
                    </template>
                    <template v-else-if="activeTabIndex === 1">
                        购物中心自助结账区引入快麦自助专用打印机和快麦云，设备故障率降低了 75%，顾客因打印问题求助工作人员的比例下降了
                        80%，自助结账成功率从原来的 85% 提升至 98%，极大提升了顾客自助购物体验。
                    </template>
                    <template v-else-if="activeTabIndex === 2">
                        鲜丰水果仓库引入快麦便携式标签打印机和番茄打印管家仓库模块后，商品标签错误率降低了 90%，仓库盘点时间缩短了
                        50%，补货效率提升了 40%，因标签问题导致的商品损耗减少了 25%，显著优化了仓库运营流程。
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from '../Header.vue';

export default {
    name: "XXLS",
    components: {Header},
    data() {
        return {
            activeTabIndex: 0,
            tabList: [
                {
                    tabName: '连锁超市 / 便利店收银台',
                    title: '连锁超市 / 便利店收银台',
                    subtitle: '连锁超市和便利店收银台是顾客购物的最后一环，日均接待数百至上千名顾客，尤其在早晚高峰和节假日，收银压力巨大。需要快速打印包含商品名称、单价、数量、总价、支付方式等信息的收银小票，同时支持会员信息、促销活动等内容的打印，确保收银流程顺畅高效。',
                    solution: '部署快麦云热敏打印机和快麦云，构建收银台高效打印体系。',
                    beds: [
                        {
                            title: '高峰时段打印卡顿',
                            text: '传统热敏打印机处理速度慢，在高峰时段易出现小票打印延迟、卡顿甚至漏打现象，导致收银台排队拥堵，影响顾客体验。'
                        },
                        {
                            title: '打印内容模糊易褪色',
                            text: '部分廉价打印机打印清晰度不足，且小票易因环境潮湿、摩擦等因素褪色，给顾客退换货和门店对账带来困扰。'
                        },
                        {
                            title: '多设备管理繁琐',
                            text: '连锁门店通常配备多台收银设备，传统打印机缺乏统一管理平台，设备故障难以及时发现，耗材更换不及时也会影响正常运营。'
                        },
                    ],
                    goods: [
                        {
                            title: '高速响应减少排队',
                            text: '打印机打印速度可达 180mm/s 以上，配合智能缓存技术，能快速处理连续收银订单，有效减少高峰时段排队时间。'
                        },
                        {
                            title: '高清耐存提升体验',
                            text: '采用高品质打印头和耐刮热敏纸，打印内容清晰锐利，且具备一定的防水、防油、防褪色特性，保障小票长期可辨，方便顾客留存和门店核对。'
                        },
                        {
                            title: '智能管理降低成本',
                            text: '通过快麦云软件可实时监控各收银台打印机状态、耗材余量，自动预警故障和缺纸情况，支持远程设置打印参数，降低人工巡检和维护成本。'
                        },
                    ]
                },
                {
                    tabName: '大型商场自助结账区',
                    title: '大型商场自助结账区',
                    subtitle: '大型商场为提升购物便利性，普遍设置自助结账区，顾客可自主完成商品扫码、支付和小票打印流程。自助结账区设备使用频率高，且缺乏专人实时维护，对打印机的稳定性、易用性和故障自恢复能力要求极高。',
                    solution: '部署快麦热敏云打印机和快麦云，打造无人化高效打印场景。',
                    beds: [
                        {
                            title: '设备故障顾客束手无策',
                            text: '自助结账机配套的打印机若出现卡纸、缺纸等故障，顾客无法自行处理，只能放弃自助结账或等待工作人员协助，影响自助设备的使用效率。'
                        },
                        {
                            title: '操作复杂影响使用体验',
                            text: '部分打印机与自助系统兼容性差，打印操作步骤繁琐，或出现支付成功后小票无法打印的情况，导致顾客抱怨。'
                        },
                        {
                            title: '数据同步不及时难追溯',
                            text: '自助结账小票打印记录与商场管理系统同步延迟，出现问题时难以快速追溯订单信息，给对账和纠纷处理带来困难。'
                        },
                    ],
                    goods: [
                        {
                            title: '故障自诊降低人工干预',
                            text: '打印机具备智能卡纸检测和自动退纸功能，缺纸时会发出清晰提示并同步至管理系统，减少因设备故障导致的顾客滞留，降低人工维护成本。'
                        },
                        {
                            title: '极简交互提升自助体验',
                            text: '优化打印触发机制，支付完成后自动启动打印，无需额外操作，且打印过程安静快速，提升顾客自助结账体验。'
                        },
                        {
                            title: '实时同步保障数据追溯',
                            text: '与自助结账系统和商场管理系统实时对接，打印记录即时上传，确保订单信息可快速查询和追溯，便于财务对账和客诉处理。'
                        },
                    ]
                },
                {
                    tabName: '零售门店仓库与补货环节',
                    title: '零售门店仓库与补货环节',
                    subtitle: '零售门店仓库负责商品存储、入库验收和补货管理，需要打印商品入库标签、库存盘点标签、补货清单等，确保商品信息准确对应，提高仓库周转效率。仓库环境相对复杂，可能存在灰尘、货物搬运碰撞等情况。',
                    solution: '部署快麦便携式热敏云标签打印机 和番茄打印管家仓库管理模块，满足仓库移动打印需求。',
                    beds: [
                        {
                            title: '标签打印不清晰易脱落',
                            text: '传统打印机打印的仓库标签清晰度不足，且粘贴不牢固，容易在货物搬运过程中脱落或磨损，导致商品信息无法识别，影响库存准确性。'
                        },
                        {
                            title: '手动录入信息效率低',
                            text: '仓库标签信息多依赖人工录入，不仅效率低下，还容易出现录入错误，导致商品与标签不符，增加盘点和补货难度。'
                        },
                        {
                            title: '移动打印需求难满足',
                            text: '仓库工作人员在货架间移动作业时，需要随时打印标签，但传统打印机多为固定安装，移动打印不便，影响工作效率。'
                        },
                    ],
                    goods: [
                        {
                            title: '耐用标签保障信息清晰',
                            text: '支持打印高粘性热敏标签，具备防水、防刮、耐磨损特性，确保标签在仓库复杂环境中长时间保持清晰完整，提升库存信息准确性。'
                        },
                        {
                            title: '数据联动减少人工错误',
                            text: '与门店 ERP 系统或库存管理系统对接，自动获取商品信息生成标签，无需人工录入，减少信息错误，提高标签打印效率。'
                        },
                        {
                            title: '便携移动提升作业灵活',
                            text: '便携式设计重量轻，支持蓝牙无线连接和电池供电，工作人员可随身携带在仓库内移动作业，随时打印所需标签，提升补货和盘点效率。'
                        },
                    ]
                },
            ]
        }
    },
    mounted() {
    },
    methods: {},
};
</script>

<style lang="scss" scoped>
@import "../business.scss";
</style>
